import { render, staticRenderFns } from "./PxModalComponent.vue?vue&type=template&id=2aa41b9b&"
import script from "./PxModalComponent.vue?vue&type=script&lang=js&"
export * from "./PxModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports